import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';

import { green, primaryColor } from '~theme';

const InfoCard = ({ children }) => {
  return (
    <Wrapper>
      <InfoIcon icon={faCircleInfo} />
      {children}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1em;

  background-color: #f2f2f2;

  padding: 8px 16px;

  font-size: 16px;
  font-weight: 700;
  color: ${primaryColor};
`;

const InfoIcon = styled(FontAwesomeIcon)`
  font-size: 22px;
  color: ${green};
`;

export default InfoCard;
